"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledCommentsContainer = exports.StyledTextBox = exports.StyledDialogContent = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDialogContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  min-height: 450px;
  overflow: hidden;
  color: ${({ theme }) => theme.palette.text.primary};
`;
exports.StyledTextBox = (0, styled_components_1.default)(ui_components_1.TextField) `
  .MuiInputBase-root {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};

    .text-box-footer {
      align-self: stretch;
      flex: 1;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid ${ui_components_1.baseColors.background100};
      padding-top: ${({ theme }) => theme.spacing(0.5)};

      .MuiButtonBase-root svg {
        color: ${({ theme }) => theme.palette.grey[400]};
        fill: none;
      }

      .Mui-disabled svg {
        cursor: default;
        color: ${({ theme }) => theme.palette.grey[200]};
      }
    }
  }
`;
exports.StyledCommentsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  flex: 1;

  .comments-container-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .comments-container-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: ${({ theme }) => theme.spacing(2, 1.5)};
    overflow-y: auto;
    max-height: 400px;
    background-color: ${ui_components_1.baseColors.background000};
    margin-bottom: ${({ theme }) => theme.spacing(1)};
    gap: ${({ theme }) => theme.spacing(1.5)};
    border-radius: ${({ theme }) => Number(theme.shape.borderRadius) * 2}px;
  }
`;
exports.StyledButton = (0, styled_components_1.default)(ui_components_1.Button) `
  .MuiButton-endIcon {
    margin-left: 0;

    .MuiSvgIcon-root {
      font-size: 1.563rem;
    }
  }
`;
